import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

const onError =
  import.meta.env.VITE_ENVIRONMENT === "development"
    ? console.error
    : undefined;
export function getContext() {
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError,
    }),
    mutationCache: new MutationCache({
      onError,
    }),
    defaultOptions: {
      queries: {
        experimental_prefetchInRender: true,
      },
    },
  });
  return {
    queryClient,
  };
}

export function Provider({
  children,
  queryClient,
}: {
  children: React.ReactNode;
  queryClient: QueryClient;
}) {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}
